export default "__VITE_ASSET__CNwzeokm__"